{
  "sharedDocuments": {
    "sharedDocuments": "Shared documents",
    "sharedWith": "Shared with",
    "shareButton": "Share with child organisations",
    "shareDescription": "Select the child organisations that should see this document once it has a published version.",
    "share": "Share",
    "documentShared": "Document shared",
    "sharedByGroup": "Shared by {{name}}",
    "sharedToGroup": "Shared to {{name}}",
    "sharedBy": "Shared by",
    "adopt": "Adopt",
    "adopted": "Adopted",
    "notAdopted": "Not adopted",
    "adoptedDetails": "Adopted {{date}} by {{name}}",
    "documentAdopted": "Document adopted",
    "readersTitle": "Readers",
    "inviteReaders": "Invite readers",
    "inviteReadersDescription": "Invite readers from your organisation. Read tracking is internal to your organisation.",
    "markAsRead": "Mark as read",
    "document": "Document",
    "byOrganisation": "By organisation",
    "toOrganisation": "To organisation",
    "readersOverview": "Readers (accepted / invited)",
    "noSharedDocuments": "No shared documents",
    "invited": "Invited",
    "opened": "Opened",
    "read": "Read"
  }
}
